import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Spinner } from "@heroui/react";
import ContractsThisYear from "shared/components/rental/sections/contracts-this-year";
import { useContractsThisYear } from "../../hooks";

const ContractsThisYearPage = () => {
  const { contracts, isLoading } = useContractsThisYear();

  if (isLoading) {
    return (
      <div className="flex h-[400px] items-center justify-center bg-neutral-50">
        <Spinner
          size="lg"
          color="primary"
          label="Contracten laden..."
          classNames={{
            wrapper: "flex flex-col items-center gap-4",
            circle1: "border-b-moss-primary",
            label: "text-moss-primary font-medium"
          }}
        />
      </div>
    );
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Afgesloten Contracten Dit Jaar | Yally</title>
        </Helmet>
      </HelmetProvider>

      <ContractsThisYear contracts={contracts} />
    </>
  );
};

export default ContractsThisYearPage;
